import * as React from "react";
import "./shipmentDetails.scss";
import { isEntitled } from "../../../utils/common";
import { getDriverName } from "../../../pages/Execute/CarrierAssigned/shipmentPage.util"
import { MODULES, CARRIER_PRO_LABEL, CAPACITY_TYPE_DRAY, CAPACITY_TYPE_POWERONLY, SHIPMENTSTATE, MANAGE_USERS_TOOLTIP_NAME } from "../../../utils/constants";
import { Persona } from "../persona/persona";
import { IonIcon } from "@ionic/react";
import { ToolTip } from "app/components/ToolTip/ToolTip";


export const ShipmentDetails: React.FunctionComponent<any> = (props: any) => {

  const getDriverNameByModule = () => {

    if (
      props.module === MODULES.DRIVER_ASSIGNED_MODULE ||
      props.module === MODULES.INTRANSIT_MODULE ||
      props.module === MODULES.RECENTLY_DELIVERED_MODULE
    ) {
      const driverName = getDriverName(props.module, props.load);
      return (<div className="driver-persona-div">
        <Persona
          name={driverName}
          showName={false}
        />
      </div>);
    }
    return ""
  }

  const getTooltipName =() =>{
    var toolTipName = MANAGE_USERS_TOOLTIP_NAME.DRIVER_ASSIGNED;
    if (props?.shipmentState === SHIPMENTSTATE.IN_TRANSIT) {
      toolTipName  = MANAGE_USERS_TOOLTIP_NAME.IN_TRANSIT
    }
    if (props?.shipmentState === SHIPMENTSTATE.DELIVERED_NEEDS_PPWK) {
      toolTipName  = MANAGE_USERS_TOOLTIP_NAME.DELIVERED_NEEDS_PPWK
    }
    if (props?.shipmentState === SHIPMENTSTATE.DELIVERED_WITH_PPWK) {
      toolTipName  = MANAGE_USERS_TOOLTIP_NAME.DELIVERED_WITH_PPWK
    }
    return toolTipName
  }

  const [toolTip, setTooltip] = React.useState<any>(null);
  const stopOffs = props?.numberOfStops - 2;
  const currencyFormatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 0
  })
  const onIndicatorClick = (event : any) =>{
    event.preventDefault();
    event.stopPropagation();
    setTooltip(getTooltipName())
    setTimeout(() => {  setTooltip(null) },5000) 
  }
  return (
    <div className="shipment-details" data-testid="shipmentDetails">
      <p className="card_p-elements loadno_card">
        {props?.showLoadNo ? props?.loadId || props?.shipmentId : ""}
      </p>
      <p className="card_p-elements card-trailerType">
        {props?.load?.capacityType === CAPACITY_TYPE_POWERONLY && <IonIcon
          className="capacity-type-icon-power-only"
          src="assets/icon/capacity_type_icon_power_only.svg" />}
        {props?.load?.capacityType === CAPACITY_TYPE_DRAY && <IonIcon
          className="capacity-type-icon-dray"
          src="assets/icon/capacity_type_icon_dray.svg" />}
        {(props?.load?.transportMode && ((props?.load?.capacityType === undefined) || (props?.load?.capacityType === null) || (props?.load?.capacityType === ""))) && props?.load?.transportMode === CAPACITY_TYPE_POWERONLY ? <IonIcon
          className="capacity-type-icon-power-only"
          src="assets/icon/capacity_type_icon_power_only.svg" /> : props?.load?.transportMode === CAPACITY_TYPE_DRAY ? <IonIcon
            className="capacity-type-icon-dray"
            src="assets/icon/capacity_type_icon_dray.svg" /> : null}
        <span className={`capacity-type ${((props?.load?.capacityType === CAPACITY_TYPE_POWERONLY) ||
          (props?.load?.capacityType === CAPACITY_TYPE_DRAY) || (props?.load?.transportMode === CAPACITY_TYPE_POWERONLY) ||
          (props?.load?.transportMode === CAPACITY_TYPE_DRAY)) ? 'capacity-type-font' : ''}`}>
          {props?.load?.capacityType ? props?.load?.capacityType : props?.load?.transportMode}
        </span>
      </p>
      {props?.trailerType && <p className="card_p-elements card-trailerType">
        {props?.trailerType === CAPACITY_TYPE_POWERONLY && <IonIcon
          className="capacity-type-icon-power-only"
          src="assets/icon/capacity_type_icon_power_only.svg" />}
        {props?.trailerType === CAPACITY_TYPE_DRAY && <IonIcon
          className="capacity-type-icon-dray"
          src="assets/icon/capacity_type_icon_dray.svg" />}
        <div className={`capacity-type ${((props?.trailerType === CAPACITY_TYPE_POWERONLY) ||
          (props?.trailerType === CAPACITY_TYPE_DRAY)) ? 'capacity-type-font' : ''}`}>
          {props?.trailerType}
        </div>
      </p>}
      {(props?.carrierPro || props?.load?.carrierPro) ? (
      <>
      <p className="card_p-elements loadno_carrierPro">
        {`${CARRIER_PRO_LABEL}`}
      </p>
      <p className="card_p-elements loadno_carrierPro">
        {`${props?.carrierPro ? props?.carrierPro : props?.load?.carrierPro}`}
      </p>
      </>
      ) : null }
      {
        <>
          {props?.rate && props?.rate?.totalCharge && props?.buyAllowed ? (
            <p className="card-price" dat-test="card-price">
              {currencyFormatter.format(Math.trunc(props?.rate?.totalCharge))}
            </p>
          ) : null}
        </>
      }
      {props?.totalDistance ? (
        <p
          className={`card-distance ${props?.showLoadNo ? "no-margin" : ""}`}
          data-testid="card-distance"
        >
          {Math.round(props?.totalDistance)} {Math.round(props?.totalDistance) === 1 ? 'mile' : 'miles'}
        </p>
      ) : null}
      {stopOffs > 0 && (
        <p className="card-stopOffs" data-test="stop-offs">
          {stopOffs > 1 ? `${stopOffs} Stop offs` : `${stopOffs} Stop off`}
        </p>
      )}
      <p className="card_p-elements card-lbs">
        {props?.totalWeight &&
          props?.totalWeight
            .toString()
            .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}{" "}
        {props?.totalWeight === 1 ? 'lb' : 'lbs'}
      </p>
      {props?.isHazardous && (
        <p className="card_p-elements card-hazmat" data-test="is-Hazardous">
          Hazmat
        </p>
      )}
      {props?.isHighValue && (
        <p className="card_p-elements card-value" data-test="is-HighValue">
          High Value
        </p>
      )}
      {(props?.specialServices &&
        props?.specialServices?.length &&
        props?.specialServices?.map((service: any, index: any) => (
          <p className="card_p-elements card-value" key={index}>
            {service.specialServiceDesc}
          </p>
        ))) ||
        null}
      {/* {(props.shipmentServices &&
        props.shipmentServices.length &&
        props.shipmentServices.map((service: any, index: any) => (
          <p className="card_p-elements card-value" key={index}>
            {service.serviceDescription}
          </p>
        ))) ||
        null} */}
      {props?.isTemperatureControlled && (
        <p className="card_p-elements card-value" data-test="is-temperature">
          Temp Control
        </p>
      )}
      {
        isEntitled('myLoad', 'filter') && !props?.isManageUserAssignedLoad && getDriverNameByModule()
      }
      <div className ={`card-tooltip ${((props?.shipmentState=== SHIPMENTSTATE.PENDING_DRIVER_ASSIGNMENT)
    || (props?.shipmentState === SHIPMENTSTATE.DRIVER_ASSIGNMENT))? 'tooltip-driver' : (props?.shipmentState === SHIPMENTSTATE.IN_TRANSIT)? 'tooltip-intransit':""}`}>
         <ToolTip message={toolTip} isActive={!!toolTip} />
        </div>
       <div onMouseEnter = {(e)=>onIndicatorClick(e)} onMouseLeave={()=> setTooltip(null)} onClick={(e)=>onIndicatorClick(e)}>
        {props?.isManageUserAssignedLoad && ((props?.shipmentState=== SHIPMENTSTATE.PENDING_DRIVER_ASSIGNMENT)
    || (props?.shipmentState === SHIPMENTSTATE.DRIVER_ASSIGNMENT)) ? <IonIcon
    className="shipment_state_manage_user"
    src="assets/icon/driver.svg" /> : null}
     {props?.isManageUserAssignedLoad && (props?.shipmentState === SHIPMENTSTATE.IN_TRANSIT) ? <IonIcon
    className="shipment_state_manage_user"
    src="assets/icon/transit.svg" /> : null}
     {props?.isManageUserAssignedLoad && (props?.shipmentState === SHIPMENTSTATE.DELIVERED_NEEDS_PPWK) ? <IonIcon
    className="shipment_state_manage_user"
    src="assets/icon/delivered.svg" /> : null}
     {props?.isManageUserAssignedLoad && (props?.shipmentState === SHIPMENTSTATE.DELIVERED_WITH_PPWK) ? <IonIcon
    className="shipment_state_manage_user"
    src="assets/icon/recent.svg" /> : null}
    </div>
    </div>
  );
};